import { createContext } from "react";

export interface KPIAdditionalFiltersType {
    startDate: Date;
    endDate: Date;
    businessEntity: string;
    operatingAsset: string;
    siteName: string[];
    selectedKpiName: string | null;
}

export interface KPIContextState {
    showKpiDetails: boolean;
    filters: KPIAdditionalFiltersType;
}

interface KPIContextProps {
    state: KPIContextState;
    updateSelectedKpiName:  (value: string) => void;
    toggleShowDetails: (value: boolean) => void;
    updateFilters: (values: KPIAdditionalFiltersType) => void;
}

export const KPIContext = createContext<KPIContextProps | null>(null);